var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 88.75,
    height: 88.75,
    rx: 44.375,
    fill: "#00A6A6",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0088,
    y: 12.3837,
    width: 63.9826,
    height: 63.9826,
    rx: 31.9913,
    fill: "#00A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4867 53.5153C41.8432 53.5153 41.1998 53.2594 40.7096 52.7502L33.1692 44.9159C32.1864 43.8948 32.1864 42.2444 33.1692 41.2233C34.152 40.2022 35.7405 40.2022 36.7233 41.2233L42.4867 47.2113L53.277 36.0004C54.2598 34.9794 55.8483 34.9794 56.8311 36.0004C57.8138 37.0215 57.8138 38.6719 56.8311 39.693L44.2637 52.7502C43.7736 53.2594 43.1301 53.5153 42.4867 53.5153Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.15af71fba7ee9e009d81cad1a5be0b9f.svg";
export { ForwardRef as ReactComponent };